import {Injectable} from "@angular/core";
import {Observable} from "rxjs/Observable";
import {BehaviorSubject} from "rxjs/BehaviorSubject";
import {Question} from "./question";
import {Quiz} from "./quiz";
import {AuthService} from "./auth.service";
import {Http, Response, RequestOptions, Headers} from "@angular/http";
import {QuestionVersion} from "./question-version";

@Injectable()
export class QuestionService {

  public questions$: BehaviorSubject<Question[]> = new BehaviorSubject<Question[]>([]);
  public questionVersion$: BehaviorSubject<QuestionVersion> = new BehaviorSubject<QuestionVersion>(null);

  constructor(private authService: AuthService,
              private  http: Http) {
    authService.currentAdmin$.subscribe(
      admin => {
        this.loadQuestionList();
      }
    );
  }

  public loadQuestionList(): void {
    this.http.get("api/question/list").subscribe(
      res => {
        const data = res.json();
        if (data.questions) {
          // console.log("new question data!");
          this.questions$.next(data.questions);
        }
        else {
          console.log("Warning: response had no questions");
        }
      },
      error => {
        console.error(error);
      }
    );
    this.http.get("api/question/version").subscribe(
      res => {
        const data = res.json();
        if (data.version) {
          this.questionVersion$.next(data.version);
        }
        else {
          console.log("Warning: response had no question version");
        }
      }
    );
  }

  addQuestion(question: Question, quiz: Quiz): Observable<boolean> {
    const body = JSON.stringify({question: question, quizId: quiz._id});
    const headers = new Headers({"Content-Type": "application/json"});
    const options = new RequestOptions({headers: headers});

    return this.http.post("api/question/", body, options)
      .map(res => {
        const data = res.json();
        if (data.status && data.status == "Success") {
          if (data.questions) {
            // console.log("new question data!");
            this.questions$.next(data.questions);
          }
          else {
            console.log("Warning: responce had no questions");
          }
          return true;
        }
        return false;
      })
      .catch(this.handleError);
  }

  saveVersion(version: QuestionVersion): Observable<boolean> {
    const body = JSON.stringify({questionVersion: version});
    const headers = new Headers({"Content-Type": "application/json"});
    const options = new RequestOptions({headers: headers});

    return this.http.post("api/question/version", body, options)
      .map(res => {
        return true;
      })
      .catch(this.handleError);
  }

  removeQuestion(id: string): Observable<boolean> {
    return this.http.delete("api/question/" + id)
      .map(res => {
        const data = res.json();
        if (data.status && data.status == "Success") {
          if (data.questions) {
            // console.log("new question data!");
            this.questions$.next(data.questions);
          }
          else {
            console.log("Warning: responce had no questions");
          }
          return true;
        }
        return false;
      })
      .catch(this.handleError);
  }

  updateQuestion(question: Question): Observable<boolean> {
    const body = JSON.stringify({question: question});
    const headers = new Headers({"Content-Type": "application/json"});
    const options = new RequestOptions({headers: headers});

    return this.http.put("api/question/", body, options)
      .map(res => {
        const data = res.json();
        if (data.status && data.status == "Success") {
          if (data.questions) {
            // console.log("new question data!");
            this.questions$.next(data.questions);
          }
          else {
            console.log("Warning: responce had no questions");
          }
          return true;
        }
        return false;
      })
      .catch(this.handleError);
  }

  private handleError(error: Response | any) {
    // In a real world app, you might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || "";
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ""} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Observable.throw(errMsg);
  }

  public getQuestion(questionID: string): Question {
    if (!this.questions$ || !this.questions$.value) {
      return null;
    } else {
      return this.questions$.value.find(q => q._id.toString() === questionID);
    }
  }

  copyQuestion(question: Question, quiz: Quiz) {
    const body = JSON.stringify({
      questionId: question._id,
      quizId: quiz._id,
    });

    const headers = new Headers({"Content-Type": "application/json"});
    const options = new RequestOptions({headers: headers});

    return this.http.put("api/question/copy", body, options)
      .map(res => res.json())
      .subscribe(questions => {
        this.questions$.next(questions);
      },
      (err) => {
        this.handleError(err);
      },
      () => {
        console.log("Stream is completed");
      });

    /*return this.http.put("api/question/copy", body, options)
      .map(res => {
        let data = res.json();
        if (data.status && data.status == "Success") {
          if (data.questions) {
            // console.log("new question data!");
            this.questions$.next(data.questions);
          } else {
            console.log("Warning: response had no questions");
          }
          if (data.quizzes) {

          }
          return true;
        }
        return false;
      })
      .catch(this.handleError);*/
  }
}



// WEBPACK FOOTER //
// ./src/app/question.service.ts